import React, { useEffect } from "react";
import { X } from "lucide-react";

const ReturnsModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="absolute max-w-3xl pb-4 mx-auto overflow-y-auto bg-white shadow-2xl h-fit inset-x-4 top-14 bottom-4 rounded-2xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gray-500">
              Returns
            </p>
            <h3 className="font-serif text-2xl text-gray-900">
              Returns & Exchanges
            </h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-500 transition rounded-full hover:text-gray-900 hover:bg-gray-100"
            aria-label="Close returns info"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-5 py-4 space-y-4 text-sm text-gray-700">
          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Return window
            </h4>
            <p>You may return or exchange your item within 7 days of receiving your order.</p>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Eligible items
            </h4>
            <ul className="space-y-1 list-disc list-inside">
              <li>Unworn</li>
              <li>In original packaging</li>
              <li>In perfect condition</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Non-returnable items
            </h4>
            <ul className="space-y-1 list-disc list-inside">
              <li>Custom-made pieces</li>
              <li>Engraved items</li>
              <li>Sale items</li>
              <li>Earrings (for hygiene reasons)</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              How to request a return
            </h4>
            <ol className="space-y-1 list-decimal list-inside">
              <li>Contact us with your order info.</li>
              <li>We will provide instructions and return approval.</li>
              <li>
                Once we receive and inspect the item, your exchange or store credit will be processed.
              </li>
            </ol>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">Refunds</h4>
            <ul className="space-y-1 list-disc list-inside">
              <li>Refunds are issued as store credit unless stated otherwise.</li>
              <li>Shipping fees are non-refundable.</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReturnsModal;
